import React from "react"
import RequestLetter from "../Services/LetterRequests/components/MyRequests/Index/index"

function RequestLetters(props) {
  return (
    <div>
      <RequestLetter myReq={true} />
    </div>
  )
}

export default RequestLetters
